import { setCookie } from '@cian/utils/lib/browser/cookie';
import { addDays } from 'date-fns';
import { parseCookies } from '@cian/utils';
import {
  MORTGAGE_BANNER_HAS_BEEN_SHOWN,
  FULL_SCREEN_BANNER_SESSION_STORAGE_KEY,
} from '../../../shared/constants/mortgage';

export const getMortgageBannerHasBeenShownCookie = () => {
  return Boolean(parseCookies(document.cookie)[MORTGAGE_BANNER_HAS_BEEN_SHOWN]);
};

export const setMortgageBannerHasBeenShownCookie = () => {
  setCookie(MORTGAGE_BANNER_HAS_BEEN_SHOWN, '1', {
    expires: addDays(new Date(), 6),
  });
};

export const getFullscreenBannerHasBeenShownSessionStorage = () => {
  return Boolean(window.sessionStorage.getItem(FULL_SCREEN_BANNER_SESSION_STORAGE_KEY));
};
